<child-header title="Association Invitation" (closeEvent)="closeAgreementPopup()"></child-header>

<div mat-dialog-content>
  <div style="margin-bottom: 15px;">Click the following button to accept this invitation and authorize Dicker Data Ltd to be your Microsoft Cloud
    Solution
    Provider.</div>
  <div *ngIf="currentUserModel?.isAU">Additional partner information: csp.support@dickerdata.com.au 1300289277</div>
  <div *ngIf="!currentUserModel?.isAU">Additional partner information: Microsoft@dickerdata.co.nz 0800 3372537</div>
</div>

<div mat-dialog-actions style="text-align: center;display: block;">
  <button mat-button class="button button-red button-mid saveupdate"
    style="margin-right: 20px;" (click)="acceptInvitation()">Accept</button>
  <button mat-button class="button button-red button-mid" (click)="closeAgreementPopup()">Close</button>
</div>
